/* 🤖 this file was generated by svg-to-ts */
export const matIconEqualizer: {
  name: 'equalizer';
  data: string;
} = {
  name: 'equalizer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"/></svg>`
};
